export const GET_AADHAAR_PAN_LINK_STATUS = 'GET_AADHAAR_PAN_LINK_STATUS'
export const GET_AADHAAR_PAN_LINK_STATUS_LOADING = 'GET_AADHAAR_PAN_LINK_STATUS_LOADING'
export const GET_AADHAAR_PAN_LINK_STATUS_SUCCESS = 'GET_AADHAAR_PAN_LINK_STATUS_SUCCESS'
export const GET_AADHAAR_PAN_LINK_STATUS_ERROR = 'GET_AADHAAR_PAN_LINK_STATUS_ERROR'
export const CLEAR_AADHAR_PAN_LINK_STATUS = 'CLEAR_AADHAR_PAN_LINK_STATUS'

export const getAadhaarPanLinkStatus = (body) => ({ type: GET_AADHAAR_PAN_LINK_STATUS, body });
export const clearAadhaarPanLinkStatus = () => ({ type: CLEAR_AADHAR_PAN_LINK_STATUS });